import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import NOB from '../../../../constants/language-strings';
import { NUMBERS_IN_LETTERS_NOB } from '../../../../constants/numbers-in-letters';
import { AgreementPrice } from './agreement-price/agreement-price';
import { ListItem } from '../../../../components/ListItem/list-item';
import ProductListElementContainer from '../../containers/CustomerProduct/product-list-element-container';
import { UpgradeDowngradeProduct } from 'modules/CustomerProducts/containers/UpgradeDowngradeProduct/upgrade-downgrade-product';
import styled from 'styled-components';
import { filterCustomerProducts, moveNewProductToBottom } from 'modules/CustomerProducts/helpers';
import { AddProduct } from 'modules/CustomerProducts/containers/addProduct/add-product';
import { PurPurButton } from 'components';
import { StatusMessage } from 'components/status-message/status-message';
import spacing from 'theme/spacing';
const CustomerProductsListContainer = styled.div `
  margin: 0 ${spacing.spacing12} ${spacing.spacing48} ${spacing.spacing12};
`;
const CustomerProductsContainer = styled.div `
  margin-top: ${spacing.spacing16};
`;
const HeadingWrapper = styled.div `
  display: flex;
  justify-content: center;
  font-size: 20px;
  margin-bottom: ${spacing.spacing16};

  span {
    font-size: 18px;
  }
`;
const StyledButtonContainer = styled.div `
  display: flex;
  justify-content: space-between;
  padding-bottom: 1rem;

  @media (max-width: 750px) {
    flex-direction: column;
  }
`;
const StyledButtonWrapper = styled.div `
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: ${spacing.spacing16};
`;
const StyledButton = styled(PurPurButton) `
  width: 320px;
`;
const ProductsWithoutDeviceItem = styled.p `
  margin: ${spacing.spacing12} 0;
`;
export const CustomerProductList = ({ customerId, agreements, isFetchingPrices, agreementsErrorMessage, customerProducts, customerProductsErrorMessage, addProduct, isAdding, addProductErrorMessage, }) => {
    const [isVisibleAddProductModal, setIsVisibleAddProductModal] = useState(false);
    const [isVisibleUpgradeDowngradeProductModal, setIsVisibleUpgradeDowngradeProductModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [selectedAgreement, setSelectedAgreement] = useState(0);
    const allCustomerProducts = useMemo(() => {
        if (!(customerProducts === null || customerProducts === void 0 ? void 0 : customerProducts.length))
            return [];
        return moveNewProductToBottom(filterCustomerProducts(customerProducts));
    }, [customerProducts]);
    const handleCloseError = () => {
        setErrorMessage(null);
    };
    const showProductButtons = !customerProductsErrorMessage && !!customerProducts && agreements.length > 0;
    /* list out all products */
    const productList = (products) => (_jsx("div", { children: products.map((product) => (_jsx(ProductListElementContainer, { product: product, customerId: customerId }, product.productId))) }));
    /* map products for upgrade/downgrade modal */
    const mappedProductOptions = allCustomerProducts.map((product) => ({
        value: String(product.agreementDetailId),
        label: product.name,
    }));
    /* show productlist with prices, add and upgrade/downgrade products button */
    const agreementProductList = agreements.map(agreement => {
        const productListFilter = allCustomerProducts.filter((singleCustomerProduct) => singleCustomerProduct.agreementId === agreement.agreementId);
        const productWithDevices = productListFilter.map(item => item.name);
        const productsInAgreementWithoutDevice = agreement.productNames.filter(item => !productWithDevices.includes(item));
        return (_jsxs(CustomerProductsListContainer, { children: [_jsx(AgreementPrice, { customerId: customerId, agreementId: agreement.agreementId, originalPrice: agreement.originalPrice, currentPrice: agreement.currentPrice, isFetchingPrices: isFetchingPrices }), _jsx("div", { children: productsInAgreementWithoutDevice.map(item => (_jsx(ProductsWithoutDeviceItem, { children: item }, item))) }), productList(productListFilter), isAdding && _jsx(ListItem, { isFetching: isAdding }), (errorMessage) && (_jsx(StatusMessage, { type: 'error', message: errorMessage, onDismiss: handleCloseError })), showProductButtons && (_jsxs(StyledButtonContainer, { children: [_jsx(StyledButtonWrapper, { children: _jsx(StyledButton, { size: "sm", type: "button", variant: "primary", onClick: () => {
                                    if (agreementsErrorMessage) {
                                        setErrorMessage('Kan ikke legge til produkter, fikk ikke hentet ut kundens agreements');
                                    }
                                    else {
                                        setIsVisibleAddProductModal(true);
                                        setSelectedAgreement(agreement.agreementId);
                                    }
                                }, children: "Legg til produkt" }) }), _jsx(StyledButtonWrapper, { children: _jsx(StyledButton, { size: "sm", type: "button", variant: "secondary", onClick: () => {
                                    setSelectedAgreement(agreement.agreementId);
                                    setIsVisibleUpgradeDowngradeProductModal(true);
                                }, children: "Oppgradering/nedgradering" }) })] }))] }, agreement.agreementId));
    });
    useEffect(() => {
        if (addProductErrorMessage) {
            setErrorMessage(addProductErrorMessage);
        }
    }, [addProductErrorMessage]);
    useEffect(() => {
        if (agreementsErrorMessage) {
            setErrorMessage('Kan ikke legge til produkter, fikk ikke hentet ut kundens agreements');
        }
    }, [agreementsErrorMessage]);
    return (_jsxs(CustomerProductsContainer, { children: [agreements.length > 1 && (_jsxs(HeadingWrapper, { children: [_jsx("span", { children: NOB.CUSTOMER_PRODUCTS.CUSTOMER_HAS }), "\u00A0", NUMBERS_IN_LETTERS_NOB[agreements.length], "\u00A0", _jsx("span", { children: NOB.CUSTOMER_PRODUCTS.AGREEMENTS })] })), agreementProductList.length > 0 ? agreementProductList : productList(allCustomerProducts), _jsx(AddProduct, { agreementId: selectedAgreement, customerId: customerId, isVisible: isVisibleAddProductModal, onClose: () => setIsVisibleAddProductModal(false), addProduct: addProduct }), _jsx(UpgradeDowngradeProduct, { agreementId: selectedAgreement, customerId: customerId, productOptions: mappedProductOptions, isVisible: isVisibleUpgradeDowngradeProductModal, onClose: () => setIsVisibleUpgradeDowngradeProductModal(false) })] }));
};
